export default defineNuxtPlugin((nuxtApp) => {
  if (process.client) {
    // Wait for the DOM to be ready
    // window.addEventListener('DOMContentLoaded', () => {
    // Listen for all button clicks on the page
    document.body.addEventListener('click', (event) => {
      console.log('click')
      // Check if the clicked element is a button
      if (event.target && (event.target.tagName === 'BUTTON' || event.target.tagName === 'IMG' || event.target.tagName === 'P' || event.target.tagName === 'DIV')) {
        // You can modify the event properties here
        nuxtApp.$gtag?.event('button_click', {
          event_category: 'user_interaction',
          event_label: event.target.innerText, // or you could use event.target.id or any other attribute
          value: 1,
        });
        // console.log('Button clicked and event tracked!');
      }
    });
    // });
  }
});
